import css from 'styled-jsx/css';
import { colors } from '../../../../themes';

export default css`
  .gdpr-cookie-banner {
    background: ${colors.grayExtraLight};
    border-bottom: 1px solid ${colors.grayLight};
    box-shadow: 0 -2px 0 0 rgba(0, 0, 0, 0.05), inset 0 1px 0 0 rgba(0, 0, 0, 0.025);
    color: ${colors.grayDeep};
    padding: 15px 18px;
    width: 100%;
  }

  .link {
    display: inline-block;
    color: inherit;
    text-decoration: underline;
  }

  .button {
    display: inline-block;
    color: inherit;
    text-transform: uppercase;
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    font-size: 11px;
    cursor: pointer;
    outline: inherit;
  }

  .button + .button {
    margin: 0 0 0 16px;
  }

  :global(.rtl) .button + .button {
    margin: 0 16px 0 0;
  }

  p {
    font-size: 0.6875rem;
    line-height: 1.45;
    margin: 0;
    padding: 0;
  }

  .buttons-wrapper {
    align-items: center;
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }

  :global(.rtl) .buttons {
    justify-content: flex-start;
  }
`;



// WEBPACK FOOTER //
// ./app/Gdpr/components/mobile/GdprCookieBanner/styles.js